import React from "react";
import { ArrowRight } from "lucide-react";
import { BLOG_POSTS } from "../data/blogPosts";

const [featuredPost, ...restPosts] = BLOG_POSTS;
const listPosts = restPosts.slice(0, 4);
const popularPosts = restPosts.slice(4, 8);

export default function BlogFeaturedPosts() {
  return (
    <section className="bg-[#F7F5FC] ">
      <div className="max-w-6xl mx-auto pb-10">
        <div className=" grid grid-cols-1 lg:grid-cols-3 gap-4">
          {/* LEFT: Featured Posts */}
          <div className="lg:col-span-2 p-5 bg-white rounded-[28px] border border-slate-100">
            <h2 className="text-[22px] font-semibold text-slate-900 mb-4">
              Featured Posts
            </h2>

            {/* Big featured post */}
            <div className="flex flex-col sm:flex-row gap-5 pb-6 ">
              <div className="sm:w-64 h-48 sm:h-40 rounded-2xl overflow-hidden bg-slate-200 shrink-0">
                <img
                  src={featuredPost.thumbnail}
                  alt={featuredPost.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1 flex flex-col">
                <h3 className="font-semibold text-[18px] text-slate-900 leading-snug mb-2">
                  {featuredPost.title}
                </h3>
                <p className="text-[14px] font-normal text-slate-500 leading-relaxed mb-4 line-clamp-2">
                  {featuredPost.excerpt}
                </p>
                <div className="mt-auto flex flex-col items-center gap-4 sm:flex-row sm:items-center sm:justify-between sm:gap-3">
                  <div className="w-full sm:w-auto flex items-center justify-between sm:justify-start gap-2.5">
                    <div className="flex items-center gap-2.5">
                      <img
                        src={featuredPost.avatar}
                        alt={featuredPost.author}
                        className="w-9 h-9 rounded-full object-cover bg-slate-200"
                      />
                      <div className="leading-tight">
                        <p className="text-[12px] font-medium text-slate-900">
                          {featuredPost.author}
                        </p>
                        <p className="text-[11px] text-[#7209B7]">
                          {featuredPost.tag}
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
                 <div className="flex items-center justify-between  ">
                    <div>
                      <span className="text-xs text-slate-400 text-right leading-snug sm:hidden">
                        {featuredPost.date}
                        <br /> {featuredPost.readTime}
                      </span>
                      <span className="text-xs text-slate-400 mt-2 ml-2 hidden sm:block">
                        {featuredPost.date} · <br/>  {featuredPost.readTime}
                      </span>
                    </div>

                    <div>
                      <a
                        href={`/blog/${featuredPost.slug}`}
                        className="flex items-center gap-1.5 text-sm font-semibold text-[#7209B7] bg-purple-50 px-4 py-2 rounded-full hover:bg-purple-100 transition-colors"
                      >
                        View <ArrowRight className="w-4 h-4" />
                      </a>
                    </div>
                  </div>
              </div>
            </div>

            {/* List posts */}
            <div className="divide-y divide-slate-100">
              {listPosts.map((post) => (
                <a
                  href={`/blog/${post.slug}`}
                  key={post.slug}
                  className="flex items-center gap-4 py-5"
                >
                  <div className="w-20 h-16 sm:w-24 sm:h-20 rounded-xl overflow-hidden bg-slate-200 shrink-0">
                    <img
                      src={post.thumbnail}
                      alt={post.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <span className="inline-block text-[11px] font-semibold text-[#7209B7] bg-purple-50 px-2.5 py-1 rounded-full mb-1.5">
                      {post.tag}
                    </span>
                    <h4 className="font-semibold text-slate-900 text-sm sm:text-base leading-snug truncate">
                      {post.title}
                    </h4>
                    <p className="text-[13px] sm:text-[12px] text-slate-500 mt-1 line-clamp-1">
                      {post.excerpt}
                    </p>
                  </div>
                  <div className="hidden sm:block text-right text-[11px] text-slate-400 shrink-0 mr-2">
                    <p>{post.date}</p>
                    <p>{post.readTime}</p>
                  </div>
                  <span
                    aria-label="Read post"
                    className="w-9 h-9 rounded-full bg-purple-50 text-[#7209B7] flex items-center justify-center shrink-0 hover:bg-purple-100 transition-colors"
                  >
                    <ArrowRight className="w-4 h-4" />
                  </span>
                </a>
              ))}
            </div>

            <div className="text-center mt-6">
              <a
                href="/blog"
                className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#7209B7] hover:underline"
              >
                View all posts <ArrowRight className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* RIGHT: Sidebar */}
          <div className="flex flex-col gap-8">
            {/* About the Blog */}
            <div className="bg-white border border-slate-100 shadow-sm rounded-2xl p-6">
              <h3 className="font-bold text-[#7209B7] text-base mb-2">
                About the Blog
              </h3>
              <p className="text-sm text-slate-600 leading-relaxed">
                SoloConnect Blog is your trusted resource for solo travel
                stories, destination guides, travel hacks, packing tips, and
                inspiration from experienced travelers around the world.
              </p>
            </div>

            {/* Popular Post */}
            <div className="bg-white border border-slate-100  rounded-2xl p-6">
              <h3 className="font-bold text-slate-900 text-base mb-4">
                <span className="sm:hidden">Featured Posts</span>
                <span className="hidden sm:inline">Popular Post</span>
              </h3>
              <div className="flex flex-col divide-y divide-slate-200/70">
                {popularPosts.map((post) => (
                  <a
                    href={`/blog/${post.slug}`}
                    key={post.slug}
                    className="flex items-center gap-3 py-3 first:pt-0 last:pb-0"
                  >
                    <div className="w-20 h-16 sm:w-14 sm:h-14 rounded-xl overflow-hidden bg-slate-200 shrink-0">
                      <img
                        src={post.thumbnail}
                        alt={post.title}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="min-w-0 flex-1">
                      <h4 className="font-Medium text-slate-900 text-[13px] leading-snug line-clamp-2">
                        {post.title}
                      </h4>
                      <p className="text-[12px] text-slate-400 mt-1 sm:hidden">
                        {post.date}
                        <br />
                        {post.readTime}
                      </p>
                      <p className="text-[12px] text-slate-400 mt-1 hidden sm:block">
                        {post.date} · {post.readTime}
                      </p>
                    </div>
                    <span
                      aria-label="Read post"
                      className="sm:hidden w-11 h-11 rounded-full bg-purple-50 text-[#7209B7] flex items-center justify-center shrink-0 hover:bg-purple-100 transition-colors"
                    >
                      <ArrowRight className="w-4 h-4" />
                    </span>
                  </a>
                ))}
              </div>
            </div>

            {/* Newsletter */}
            <div className="bg-white border border-slate-100 shadow-sm rounded-2xl p-6">
              <h3 className="font-bold text-slate-900 text-[17px] mb-2">
                Let's Stay Connected!
              </h3>
              <p className="text-[13px] text-slate-500 leading-relaxed mb-4">
                Subscribe to receive the latest travel stories, destination
                guides, exclusive tips, and solo travel inspiration directly in
                your inbox.
              </p>
              <form
                className="flex flex-row items-center gap-2"
                onSubmit={(e) => e.preventDefault()}
              >
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="flex-1 min-w-0 rounded-[13px] bg-[#F7F5FC] px-10 py-2.5 text-[14px] text-slate-900 placeholder:text-slate-400 focus:outline-none"
                />
                <button
                  type="submit"
                  className="bg-[#7209B7] text-white font-semibold text-[12px] px-5 py-2.5 rounded-[13px] hover:bg-[#5a07a0] transition-colors shrink-0"
                >
                  Subscribe
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
